import BenchIcon from "@/assets/bench.svg?react";
import { cx } from "class-variance-authority";

export function BenchLogoSmall({ className }: { className?: string }) {
  return (
    <BenchIcon
      width={32}
      className={cx(
        "stroke-[1.5] inline-block text-primary stroke-primary",
        className
      )}
    />
  );
}
